module.exports = __webpack_public_path__ + "img/user-guide-02-06-02.75a80f8a.png";